import { useCallback, useSyncExternalStore } from 'react';

const STORAGE_KEY = 'bonusly:one-on-ones-preview';

const getSnapshot = (): boolean => {
	return localStorage.getItem(STORAGE_KEY) === 'true';
};

const getServerSnapshot = (): boolean => {
	return false;
};

const subscribe = (callback: () => void): (() => void) => {
	const handleStorageChange = (event: StorageEvent) => {
		if (event.key === STORAGE_KEY) {
			callback();
		}
	};

	window.addEventListener('storage', handleStorageChange);
	return () => window.removeEventListener('storage', handleStorageChange);
};

export const usePreviewPreference = () => {
	const isPreviewEnabled = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

	const enablePreview = useCallback(() => {
		localStorage.setItem(STORAGE_KEY, 'true');
		// Dispatch a custom event to trigger re-render in the same window
		window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEY, newValue: 'true' }));
	}, []);

	const disablePreview = useCallback(() => {
		localStorage.removeItem(STORAGE_KEY);
		// Dispatch a custom event to trigger re-render in the same window
		window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEY, newValue: null }));
	}, []);

	return {
		isPreviewEnabled,
		enablePreview,
		disablePreview,
	};
};
